import { Col, Form, Row, Button, Container, InputGroup, FormControl, Badge, Tab, Image, ListGroup, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { AddNewEditor, addTags, deleteTags } from "../../services/api";
import { AddProductSchema } from "../../utils/validation_schemas";
import { createProductFormData } from "../../utils/payloads";
import ErrorAlert from "../ErrorAlert";
import useNotification from "../../contexts/notification";
import Select from 'react-select';
import useCategories from "../../hooks/useCategories";
import useTypes from "../../hooks/useTypes";
import useBadges from "../../hooks/useBadges"
import { MdLink, MdAdd, MdRemoveCircle } from 'react-icons/md';
//import ReactQuill from 'react-quill';
//import 'react-quill/dist/quill.snow.css';
import { Editor } from '@tinymce/tinymce-react';
export default function AddNewForm({ onSubmit }) {
  const tinymceScriptSrc = 'https://cdn.tiny.cloud/1/htwonga7qqiz96jdlavjriv28pllfct0g3qg18kbyml6xxos/tinymce/6/tinymce.min.js';

  const [status, setStatus] = useState("start");
  const clearStatus = () => setStatus({ status: "start" });
  const { setMessage } = useNotification();
  const [partners, setPartners] = useState([]);
  const [images, setImages] = useState([]);
  const categories = useCategories();
  const types = useTypes();
  const [selectedImageId, setSelectedImageId] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [key, setKey] = useState('upload');
  const badge = useBadges()
  const [tags, setTags] = useState([]); // State para gerenciar as tags
  const [tagInput, setTagInput] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      image: undefined,
      type_id: null,
      top_news: "0",
      subtitle: "",
      slug: '',
      badges: null,
      category_id: undefined,
      tags: [],
      meta_description: ''
    },
    validationSchema: AddProductSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setSubmitting(true);

      await AddNewEditor(createProductFormData(values));
      setMessage({
        error: false,
        content: "Produto adicionado com sucesso",
      });
      setSubmitting(false);
      onSubmit?.();
    },
  });
  const typeOptions = types.map(type => ({ value: type.id, label: type.name }));
  const categoryOptions = categories.map(category => ({ value: category.id, label: category.name }));

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    formik.setFieldValue('name', newTitle);
    // Gerar slug automaticamente a partir do título, mas somente se o slug ainda não foi manualmente editado pelo usuário
    if (!formik.touched.slug) {
      const newSlug = newTitle.toLowerCase().replace(/[\s]+/g, '-').replace(/[^\w-]+/g, '');
      formik.setFieldValue('slug', newSlug);
    }
  };
  const handleAddTag = async () => {
    const tagTrimmed = tagInput.trim();
    if (tagTrimmed) {
      const data = { name: tagTrimmed };

      const result = await addTags(data);
      if (result.success) {
        const newTag = result.tag; // Supõe que 'tag' é o objeto completo { id, name }
        const newTags = [...formik.values.tags, newTag]; // Armazena o objeto completo
        formik.setFieldValue('tags', newTags);
        setTagInput('');
      } else {
        console.error('Erro ao adicionar tag');
      }
    }
  };

  const handleRemoveTag = async (tagToRemove) => {
    // Tenta remover a tag através da API
    const result = await deleteTags(tagToRemove);
    if (result.success) {
      // Se a tag foi removida com sucesso no backend, atualize o estado local
      const newTags = formik.values.tags.filter(tag => tag.id !== tagToRemove.id);
      formik.setFieldValue('tags', newTags);
    } else {
      // Tratar o caso de falha na remoção da tag
      console.error('Erro ao remover a tag:', result.error);
    }
  };



  return (
    <Container className="mt-4">
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Tipo de publicação*</Form.Label>
              <Select
                options={typeOptions}
                name="type_id"
                value={typeOptions.find(option => option.value === formik.values.type_id)}
                onChange={option => formik.setFieldValue('type_id', Number(option.value))}
                onBlur={() => formik.setFieldTouched('type_id', true)}
                placeholder="Selecione o tipo"
                noOptionsMessage={() => "Nenhuma opção disponível"}
                classNamePrefix="select"
              />
              {formik.touched.type_id && formik.errors.type_id && (
                <div className="invalid-feedback d-block">{formik.errors.type_id}</div>
              )}
            </Form.Group>
          </Col>

          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Categoria*</Form.Label>
              <Select
                options={categoryOptions}
                name="category_id"
                value={categoryOptions.find(option => option.value === formik.values.category_id)}
                onChange={option => formik.setFieldValue('category_id', option.value)}
                onBlur={() => formik.setFieldTouched('category_id', true)}
                placeholder="Selecione a categoria"
                noOptionsMessage={() => "Nenhuma opção disponível"}
                classNamePrefix="select"
              />
              {formik.touched.category_id && formik.errors.category_id && (
                <div className="invalid-feedback d-block">{formik.errors.category_id}</div>
              )}
            </Form.Group>
          </Col>

          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Slug (URL)*</Form.Label>
              <InputGroup>
                <InputGroup.Append>
                  <InputGroup.Text><MdLink /></InputGroup.Text>
                </InputGroup.Append>
                <FormControl
                  type="text"
                  name="slug"
                  onChange={formik.handleChange}
                  value={formik.values.slug}
                  placeholder="URL automática ou manual"
                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            <Form.Group className="mb-4">
              <Form.Label>Título*</Form.Label>
              <Form.Control
                type="text"
                name="name"
                onChange={handleTitleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.name && !!formik.errors.name}
                value={formik.values.name}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.name}
              </Form.Control.Feedback>

              <Form.Label>Subtítulo *</Form.Label>
              <Form.Control
                className="my-1"
                as="textarea"
                rows={3}
                name="subtitle"
                placeholder="Subtítulo da noticia"
                onChange={formik.handleChange}
                value={formik.values.subtitle}
                isValid={formik.touched.subtitle && !formik.errors.subtitle}
                isInvalid={formik.errors.subtitle}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.subtitle}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Conteúdo*</Form.Label>
              <Editor
                apiKey="htwonga7qqiz96jdlavjriv28pllfct0g3qg18kbyml6xxos"
                tinymceScriptSrc={tinymceScriptSrc}
                initialValue=""
                init={{
                  height: 500,
                  menubar: true,
                  language: 'pt_BR',
                  language_url: 'https://cdn.tiny.cloud/1/htwonga7qqiz96jdlavjriv28pllfct0g3qg18kbyml6xxos/tinymce/6/langs/pt_BR.js',
                  plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'mediaembed', 'table', 'help', 'wordcount'
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic backcolor | ' +
                    'alignleft aligncenter alignright alignjustify | ' +
                    'bullist numlist outdent indent | removeformat | image media mediaembed table',
                  images_upload_url: '/api/upload-image',
                  automatic_uploads: true,
                  images_upload_handler: (blobInfo) => {
                    return new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        const base64 = reader.result;
                        if (typeof base64 === 'string' && base64.startsWith('data:image')) {
                          resolve(base64);
                        } else {
                          reject('Formato de imagem inválido');
                        }
                      };
                      reader.onerror = () => reject('Erro ao ler o arquivo');
                      reader.readAsDataURL(blobInfo.blob());
                    });
                  },
                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                value={formik.values.description}
                onEditorChange={(value) => formik.setFieldValue('description', value)}
                onBlur={() => formik.setFieldTouched('description', true)}
              />

              {formik.touched.description && formik.errors.description && (
                <div className="invalid-feedback d-block">{formik.errors.description}</div>
              )}
            </Form.Group>

          </Col>
          <Col sm={4}>
            <Form.Group className="mb-4">
              <Form.Label>Imagem destaque*</Form.Label>
              <div
                className="custom-file-upload"
                onClick={() => document.getElementById('fileInput').click()}
                style={{
                  border: '2px dashed #ccc',
                  width: '192px',
                  height: '108px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                Escolher imagem
                <br />
                1920x1080
              </div>
              <Form.Control
                type="file"
                name="image"
                id="fileInput"
                style={{ display: 'none' }}
                onChange={(event) => formik.setFieldValue('image', event.currentTarget.files[0])}
                onBlur={() => formik.setFieldTouched('image', true)}
                isInvalid={formik.touched.image && !!formik.errors.image}
              />
              {formik.touched.image && formik.errors.image && (
                <div className="invalid-feedback d-block">{formik.errors.image}</div>
              )}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Emblemas*</Form.Label>
              {badge.map((badgeItem) => (
                <Form.Check
                  key={badgeItem.id}
                  type="radio"
                  label={badgeItem.name}
                  name="badges"
                  value={badgeItem.id}
                  onChange={(e) => formik.setFieldValue('badges', parseInt(e.target.value))}
                  checked={formik.values.badges === badgeItem.id}
                  onBlur={() => formik.setFieldTouched('badges', true)}
                />
              ))}
              {formik.touched.badges && formik.errors.badges && (
                <div className="invalid-feedback d-block">{formik.errors.badges}</div>
              )}


            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Tags</Form.Label>
              <InputGroup>
                <FormControl
                  type="text"
                  placeholder="Adicione tags"
                  value={tagInput}
                  onChange={e => setTagInput(e.target.value)}
                  onKeyPress={event => {
                    if (event.key === 'Enter' && !submitting) {
                      event.preventDefault();
                      handleAddTag();
                    }
                  }}
                />
                <InputGroup.Append>
                  <InputGroup.Text onClick={handleAddTag}><MdAdd /></InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div>
                {formik.values.tags.map((tag, index) => (
                  <Badge key={index} pill className="mr-2">
                    {tag.name} {/* Exibe o nome da tag */}
                    <MdRemoveCircle onClick={() => handleRemoveTag(tag)} style={{ cursor: 'pointer', marginLeft: '10px' }} />
                  </Badge>
                ))}
              </div>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Preview do Google</Form.Label>
              <FormControl
                as="textarea"
                rows="3"
                placeholder="Insira uma metadescrição relacionada ao conteúdo."
                value={formik.values.meta_description}
                onChange={e => formik.setFieldValue('meta_description', e.target.value)}
              />
              <Form.Text className="text-muted">
                Se o campo ficar em branco, o Google tentará encontrar uma parte relevante do conteúdo para mostrar nos resultados da pesquisa.
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
        <Form.Check
          className="my-1"
          type="checkbox"
          name="top_news"
          label="Colocar Noticias em Destaque?"
          onChange={(e) => {
            formik.setFieldValue("top_news", e.target.checked ? "1" : "0");

          }}
          value={formik.values.top_news === "1"}
        />
        <Button type="submit" disabled={submitting} className="mb-4">Adicionar Publicação</Button>
      </Form>
    </Container >
  );
}
